// extracted by mini-css-extract-plugin
module.exports = {"body":"game_body__jlfFx","head":"game_head__2v-O6","headtext":"game_headtext__33mDi","svg":"game_svg__2NNIs","question":"game_question__9L-25"};